// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface CheckSmallIconSignature {
  Element: SVGSVGElement;
}

export const CheckSmallIcon: TOC<CheckSmallIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.6 17.4L5.79999 13.6L6.99999 12L10.2 14.6L16 8L17.6 9.2L10.6 17.4Z"/>
</svg>
</template>;